import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlDecode',
  standalone: true,
})
export class HtmlDecodePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    // Create a temporary DOM element to decode HTML entities
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }
}
